import { useMemo } from 'react';
import { useMedia } from 'react-use';
import { Button, Chip } from '@c2fo/liquidity';

interface SuggestedTemplateCardProps {
  title: string;
  description: string;
  chipLabel: string;
  chipColorVariant: ChipStyle;
  svgImgSrc: string;
  onClick: () => void;
  buttonLabel: string;
}

type ChipStyle = 'purple' | 'pink' | 'orange' | 'green';

const SuggestedTemplateCard = ({
  title,
  description,
  chipLabel,
  chipColorVariant,
  svgImgSrc,
  onClick,
  buttonLabel,
}: SuggestedTemplateCardProps) => {
  const isMobile = useMedia('(max-width: 48rem)'); // Matches tailwind breakpoint for 'md'

  const chipClassName = useMemo(() => {
    switch (chipColorVariant) {
      case 'purple':
        return 'bg-purple-100 text-purple-900';
      case 'pink':
        return 'bg-pink-100 text-pink-900';
      case 'orange':
        return 'bg-orange-100 text-orange-900';
      case 'green':
        return 'bg-green-100 text-green-900';
      default:
        return '';
    }
  }, [chipColorVariant]);

  return (
    <div className="rounded-lg bg-white p-8 shadow-md">
      <div className="flex items-start justify-between pb-2">
        <img src={svgImgSrc} alt={title} className="h-[70px] w-[70px] shrink-0 grow-0" />
        <Chip label={chipLabel} className={chipClassName} />
      </div>
      <div className="space-y-2 pb-4">
        <h3 className="m-0 p-0 text-base font-semibold">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <div className="flex justify-end">
        <Button variant="secondary" size={isMobile ? 'md' : 'sm'} onClick={onClick} full={isMobile}>
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

export default SuggestedTemplateCard;
